import { render, staticRenderFns } from "./Comgens.vue?vue&type=template&id=64f7e5a6&"
import script from "./Comgens.vue?vue&type=script&lang=js&"
export * from "./Comgens.vue?vue&type=script&lang=js&"
import style0 from "./Comgens.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports